import { HasAccess } from 'components';
import { useLeadByIdQuery } from 'api';
import React, { useCallback } from 'react';
import { ADMIN_ROUTES } from 'constants/routes';
import { PERMISSIONS } from 'constants/permissions';
import { Tasks } from 'components/common/tasks/tasks';
import { useNavigate, useParams } from 'react-router-dom';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const LeadTasks = React.memo(() => {
  const { id } = useParams() as { id: string };
  const navigate = useNavigate();
  const { hasAccess } = useAccessControl();
  const { data: { isFinalStatus } = {} } = useLeadByIdQuery({ id }, { skip: !id });
  const onAdd = useCallback(
    () =>
      navigate(ADMIN_ROUTES.leads.createTask, {
        state: {
          entityName: 'LEAD',
          entityId: id,
        },
      }),
    [navigate, id]
  );
  const onRedirectToTask = useCallback(
    (value: string) => navigate(`${ADMIN_ROUTES.leads.view}/${id}/tasks/${value}`),
    [navigate, id]
  );
  return (
    <HasAccess role={PERMISSIONS.tasks.task.read}>
      <Tasks
        entityType="LEAD"
        entityId={id}
        hasAccessToWrite={hasAccess(PERMISSIONS.tasks.task.write) && !isFinalStatus}
        hasAccessToDelete={hasAccess(PERMISSIONS.tasks.task.delete) && !isFinalStatus}
        showAnalytics={false}
        onTaskAdd={onAdd}
        onRedirectToTask={onRedirectToTask}
      />
    </HasAccess>
  );
});
